import { Component } from "@angular/core";

@Component({
    selector: "app-menu-overlay",
    templateUrl: "./menu-overlay.component.html",
    styleUrls: ["./menu-overlay.component.scss"],
})
export class MenuOverlayComponent {}
